import { useState, useEffect } from 'react';
import quotesData from '../../data/quotes.json';

/**
 * Hook to select and manage a random quote
 * @returns {Object|null} Random quote object with quote and author, or null
 */
export const useRandomQuote = () => {
  const [randomQuote, setRandomQuote] = useState(null);

  useEffect(() => {
    // Select a random quote on component mount
    const randomIndex = Math.floor(Math.random() * quotesData.length);
    setRandomQuote(quotesData[randomIndex]);
  }, []);

  return randomQuote;
};
